let routes = [];
let matches = require.context('.', true, /^\.\/([\s\S]+\/)+[\s\S]+\.js$/);

matches.keys().forEach(key => {
  routes = routes.concat(matches(key).default);
});

export default routes;
